import { LeftOutlined } from '@ant-design/icons'
import { useQueryClient } from '@tanstack/react-query'
import { Button, Flex, Form } from 'antd'
import { useNavigate } from 'react-router-dom'

import {
  useStocksServiceCreateProductEndpoint,
  useStocksServiceGetMedicineListEndpointKey
} from 'src/api/queries'
import { ApiError } from 'src/api/requests'
import { FormFooter, message, PageBreadcrumbs } from 'src/components'
import { useLocales } from 'src/locales'
import { paths } from 'src/paths'
import { formErrorHandler } from 'src/utils'

import { ProductFields } from '../components'

export const CreateProductPage = () => {
  const { t } = useLocales()
  const [form] = Form.useForm()

  const queryClient = useQueryClient()
  const navigate = useNavigate()

  const { mutate, isPending } = useStocksServiceCreateProductEndpoint({
    onError: (e: ApiError) => form.setFields(formErrorHandler(e.body.errors)),
    onSuccess: () => {
      message.success(t('common.save_success'))
      queryClient.invalidateQueries({
        queryKey: [useStocksServiceGetMedicineListEndpointKey]
      })
      navigate(paths.medicinesRegister.products.root)
    }
  })

  const onCancel = () => {
    form.resetFields()
    navigate(paths.medicinesRegister.products.root)
  }

  const onSubmit = async () => {
    const requestBody = await form.validateFields()

    mutate({
      requestBody: {
        ...requestBody,
        groupId: requestBody.groupId.value
      }
    })
  }

  return (
    <PageBreadcrumbs
      items={[
        {
          title: t('menu.medicines_register')
        },
        {
          title: t('medicine_register.products.title')
        },
        {
          title: t('medicine_register.products.add')
        }
      ]}
      title={t('medicine_register.products.add')}
    >
      <Flex vertical gap={24}>
        <Flex justify="space-between" gap={16}>
          <Button icon={<LeftOutlined />} onClick={onCancel}>
            {t('common.back')}
          </Button>
        </Flex>

        <Form form={form} layout="vertical" requiredMark={false}>
          <ProductFields form={form} />

          <FormFooter
            onCancel={onCancel}
            onSave={onSubmit}
            saveConfirmTitle={`${t('common.add')}?`}
            saveLabel={t('common.add')}
            loading={isPending}
          />
        </Form>
      </Flex>
    </PageBreadcrumbs>
  )
}
